import { FieldVersionCard } from './FieldVersionCard';

import style from './FieldVersionList.module.scss';

export interface FieldVersionListProps {}

interface Props extends FieldVersionListProps {
    updateTimes: string[];
    name: string;
}

export function FieldVersionList({ name, updateTimes = [] }: Props) {
    return (
        <div className={style.root}>
            {updateTimes.map(updateTime => (
                <div
                    key={updateTime}
                    className={style.fieldVersion}
                >
                    <FieldVersionCard
                        name={name}
                        updateTime={updateTime}
                    />
                </div>
            ))}
        </div>
    );
}
